let catalogProductsArray = document.querySelectorAll('.quick-add__size'),
		popUpCloseButtonsArray = document.querySelectorAll('.productPopUp--close'),
		popUp = document.querySelector('.productPopUp'),
		productAddToCartButton = document.querySelector('.add-to-cart'),
		cartAddButtonsArray = document.querySelectorAll('.minicart-quick-add-to-cart-btn'),
		popUpOverlay = document.querySelector('.productPopUp__overlay'),
		headerCartText = document.querySelector('.minicart-toggle-btn'),
		fullPageProductButtonsArray = document.querySelectorAll('.collectionFullpageProduct__contentFooterButton:not(.collectionFullpageProduct__contentFooterButton--preorder)'),
		fullPageTemplate = document.querySelector('.collectionFullpage__list.products');

const uniqID = uuidv4();

function initSlider() {
	const sliderSettings = {
    infinite: false,
    dots: true,
    arrows: false,
    slidesToShow: 1.03,
    slidesToScroll: 1
  };

	$('.productPopUp__alsoBought--slider').each(function() {
		$(this).slick(sliderSettings);

		if (window.is_cleaner_hidden) {
			$(this).slick("slickFilter", ":not(.slide-hidden)");
		}
	});
};

initSlider();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

 const moneyFormat = '${{amount}}';
	/**
		* Format money values based on your shop currency settings
		* @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
		* or 3.00 dollars
		* @param  {String} format - shop money_format setting
		* @return {String} value - formatted value
	*/

	function formatMoney(cents, format) {
		 if (typeof cents === 'string') {
			 cents = cents.replace('.', '');
		 }
		 let value = '';
		 const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		 const formatString = format || moneyFormat;

		 function formatWithDelimiters(
			 number,
			 precision = 2,
			 thousands = ',',
			 decimal = '.'
		 ) {
			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			const parts = number.split('.');
			const dollarsAmount = parts[0].replace(
			 /(\d)(?=(\d\d\d)+(?!\d))/g,
			 `$1${thousands}`
			);
			const centsAmount = parts[1] ? decimal + parts[1] : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
		 case 'amount':
			 value = formatWithDelimiters(cents, 2);
			 break;
		 case 'amount_no_decimals':
			 value = formatWithDelimiters(cents, 0);
			 break;
		 case 'amount_with_comma_separator':
			 value = formatWithDelimiters(cents, 2, '.', ',');
			 break;
		 case 'amount_no_decimals_with_comma_separator':
			 value = formatWithDelimiters(cents, 0, '.', ',');
			 break;
		}

		return formatString.replace(placeholderRegex, value.replace(".00", ""));
	}

	/* End currency */

	/* Get cookie */
	window.getCookie = function getCookie(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');

		for(var i = 0; i < ca.length; i++) {
			var c = ca[i];

			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}

			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}

		return "";
	}
	/* End get cookie */

	async function checkProductData(data) {
		const currentDate = new Date();
		const expirationDate = new Date(currentDate.getTime() + 30 * 60 * 1000);
		const expires = expirationDate.toUTCString();

		if (data.items.length > 1) {
			data.items.forEach((item) => {
				if(/\d/.test(item.variant_title) && !item.product_type.includes('Accessories')) {
					document.cookie = `isProduct=${item.variant_title}; expires=${expires}; path=/`;
					document.cookie = `productType=${item.product_type}; expires=${expires}; path=/`;
					document.cookie = `productId=${item.id}; expires=${expires}; path=/`;
				}
			});
		} else {
			if(/\d/.test(data.items[0].variant_title) && !data.items[0].product_type.includes('Accessories')) {
				document.cookie = `isProduct=${data.items[0].variant_title}; expires=${expires}; path=/`;
				document.cookie = `productType=${data.items[0].product_type}; expires=${expires}; path=/`;
				document.cookie = `productId=${data.items[0].id}; expires=${expires}; path=/`;
			}
		}
	}

	function addOffsetTop() {
		const { y } = document.querySelector('body').getBoundingClientRect();

		document.querySelector('body').style.top = `${y}px`;
	}

	function removeOffsetTop() {
		if (document.querySelector('body').style.top != 'unset') {
			const y = -parseInt(document.querySelector('body').style.top);

			document.querySelector('body').style.top = 'unset';

			setTimeout(() => {
				window.scrollTo(0, y);
			}, 0);
		}
	}

	async function addToCart(event) {
		let currentProduct = event.target,
				selectedSwatch = document.querySelector('.selected-swatch input'),
				currentVariant = new URLSearchParams(window.location.search).get('variant'),
				currentID = currentProduct.dataset.bundleIdFirst ? parseInt(currentProduct.dataset.bundleIdFirst) :
					currentProduct.dataset.alsoBoughtId ? parseInt(currentProduct.dataset.alsoBoughtId) :
					window.location.pathname.includes('search') ? currentProduct.dataset.id :
					currentProduct.dataset.id ? currentProduct.dataset.id :
					parseInt(currentVariant) ? parseInt(currentVariant) :
					currentProduct.dataset.id,
				currentQuantity = currentProduct.dataset.alsoBoughtQuantity ? parseInt(currentProduct.dataset.alsoBoughtQuantity) :
					currentProduct.dataset.quantity ? currentProduct.dataset.quantity :
					selectedSwatch.dataset.quantity ? selectedSwatch.dataset.quantity :
					currentProduct.dataset.quantity,
				properties = {},
                currentSellingPlanElement = document.querySelector('input[name="selling_plan"]') ? document.querySelector('input[name="selling_plan"]') : null,
				currentSellingPlan = document.querySelector('input[name="selling_plan"]') ? document.querySelector('input[name="selling_plan"]').value : null,
				currentCollectionProduct = currentProduct.closest('.product__wrapper'),
				collectionProductDiscount = currentCollectionProduct ? currentCollectionProduct.querySelector('[data-discount-collection]') : null,
				collectionDiscountValue = currentCollectionProduct ? currentCollectionProduct.querySelector('[data-discounted-price]') : null,
				customerEmail = document.querySelector('[data-account]'),
        gatedFlowToggle = document.querySelector('gated-flow-toggle'),
				currentPrice = event.currentTarget.closest("[data-product-price]");


		currentSellingPlan = '';

		if (currentProduct.querySelector('span')?.dataset.addToCartText === 'PRE-ORDER') {
			properties[`Pre-Ordered Items`] = "true";
			properties[`_Fake Pre-Ordered`] = "true";
		}

		if (event.target.dataset.isFirstCustomer) {
			properties[`_isFirstCustomer`] = "true";
		}

		if (currentProduct.dataset.inventoryQuantity) {
			properties[`_inStock`] = currentProduct.dataset.inventoryQuantity;
		}

		if (collectionProductDiscount?.dataset.discountCollection) {
			properties[`_discountCollection`] = collectionProductDiscount.dataset.discountCollection;
		}

		if (collectionDiscountValue?.dataset.discountedPrice) {
			properties[`_discountValue`] = collectionDiscountValue.dataset.discountedPrice;
		}

		if (currentProduct.dataset.discount) {
			properties[`_compareAtPrice`] = currentProduct.dataset.discount;
		}

		if (document.querySelector('.pre_order')) {
			properties._pre_order = true;
		}

		if (document.querySelector('.product__buttonsMarketplace')) {
			properties._marketplace = true;
		}

		if (currentProduct.dataset.price) {
			rdt('track', 'AddToCart', {
				"currency": "USD",
				"itemCount": 1,
				"value": currentProduct.dataset.price.replace('.', ''),
			});
		}

		let secondBundleProduct = {},
				thirdBundleProduct= {};

		properties._productPrice = currentPrice?.dataset.productPrice;
		properties._generatedId = Date.now();

		if (currentProduct.dataset.bundleIdFirst) {
			const bundleTitle = document.querySelector("[data-bundle-title]").dataset.bundleTitle;
			const bundleCheckoutImage = document.querySelector("[data-bundle-image-checkout]").dataset.bundleImageCheckout;

			properties._bundle = uniqID;
			properties._bundleTitle = bundleTitle;
			properties._bundleImage = bundleCheckoutImage;
		}

		let formData = {
			items: [{
				id: parseInt(currentID),
				quantity: parseInt(currentQuantity ? currentQuantity : 1),
				properties,
				selling_plan: currentSellingPlan,
			}],
			attributes: {
				"ga4_user_id": getFirstNonDeletedCookie('_ga_XPYPPV3XZQ') ? getFirstNonDeletedCookie('_ga_XPYPPV3XZQ') : '',
			}
		};

		/* Chech if we have to add a bundle */
		if (currentProduct.dataset.bundleIdFirst) {
			const bundleTitle = document.querySelector("[data-bundle-title]").dataset.bundleTitle;
			const bundleCheckoutImage = document.querySelector("[data-bundle-image-checkout]").dataset.bundleImageCheckout;

			/* Second bundle item */
			[secondBundleProduct.id, secondBundleProduct.quantity, secondBundleProduct.properties] =
			[parseInt(currentProduct.dataset.bundleIdSecond), 1, {_bundle: uniqID, _bundleTitle: bundleTitle, _bundleImage: bundleCheckoutImage}];

			/* Third bundle item */
			[thirdBundleProduct.id, thirdBundleProduct.quantity, thirdBundleProduct.properties] =
			[parseInt(currentProduct.dataset.bundleIdThird), 1, {_bundle: uniqID, _bundleTitle: bundleTitle, _bundleImage: bundleCheckoutImage}];

			formData.items.push(secondBundleProduct);
			formData.items.push(thirdBundleProduct);
		}
		/* End checking */

		if (currentProduct.closest('button.add-to-cart')) {
			currentProduct.closest('button.add-to-cart').classList.add('add-to-cart--loading');
		}

		const productResponse = await fetch(`${currentProduct.dataset.link}`);
		const productLayout = new DOMParser().parseFromString(await productResponse.text(), 'text/html');
		const productUpsellList = productLayout.querySelector('.product .productPopUp__list');
		const productUpsellContent = productLayout.querySelector('.product .productPopUp__content');
		const productUpsellDescription = productLayout.querySelector('.productPopUp__mainProductDscription');
		const cartDrawerUpsell = document.querySelector('.productPopUp .productPopUp__upsell');
		const sellingPlanResponse = gatedFlowToggle && gatedFlowToggle.style.display != "none" && document.querySelector('.tn-gate-toggle-input').checked ? productLayout.querySelector('input[name="selling_plan"]').value : '';

		if (productUpsellList && productUpsellContent) {
			const cartDrawerUpsellList = document.querySelector('.productPopUp .productPopUp__upsell .productPopUp__list');
			const cartDrawerUpsellContent = document.querySelector('.productPopUp .productPopUp__upsell .productPopUp__content');
			const cartDrawerUpsellMainProduct = document.querySelector('.productPopUp .productPopUp__upsellMainProduct');
			const productUpsellMainDescription = cartDrawerUpsellMainProduct.querySelector('.productPopUp__mainProductDscription');
			const mainProductImage = cartDrawerUpsellMainProduct.querySelector('.productPopUp__mainProductImage');
			const currentItemID = document.querySelector(`.quick-add__size[data-id="${currentProduct.dataset.id}"]`)
				? document.querySelector(`.quick-add__size[data-id="${currentProduct.dataset.id}"]`).dataset.size
				: document.querySelector('.product__dropdownMainTitle') ? document.querySelector('.product__dropdownMainTitle').dataset.size
				: document.querySelector(`.selected-swatch label`).innerText;

			cartDrawerUpsellList.innerHTML = productUpsellList.innerHTML;
			productUpsellContent.innerHTML = cartDrawerUpsellContent.innerHTML;
			mainProductImage.src = currentProduct.dataset.image;
			productUpsellMainDescription.innerHTML = productUpsellDescription.innerHTML;

			const mainProductSize = cartDrawerUpsellMainProduct.querySelector('.productPopUp__mainProductDscription span');
			mainProductSize.innerHTML = currentItemID;
			cartDrawerUpsell.classList.add('productPopUp__upsell--active');

			const upsellButton = document.querySelector('.productPopUp__button');
			const upsellButtonContinue = document.querySelector('.productPopUp__button--continue');
			const productPopUp = document.querySelector('.productPopUp__wrapper');
			const popUpOverlayBundle = document.querySelector('.productPopUp__overlayBundle');

			productPopUp.classList.add('productPopUp--hidden');
			popUpOverlayBundle.classList.add('productPopUp__overlayBundle--active');

			checkboxHandler(currentItemID);

			upsellButton.addEventListener('click', (e) => {
				addBundle(currentID, sellingPlanResponse, currentPrice?.dataset.productPrice, true);
			});

			popUpOverlayBundle.addEventListener('click', (e) => {
				addBundle(currentID, sellingPlanResponse, currentPrice?.dataset.productPrice, true);
			});

			upsellButtonContinue.addEventListener('click', (e) => {
				addBundle(currentID, sellingPlanResponse, currentPrice?.dataset.productPrice, false);
			});

			openPopUp();

			if (document.querySelector('.add-to-cart--loading')) {
				setTimeout(() => {
					document.querySelector('.add-to-cart--loading').classList.remove('add-to-cart--loading');
				}, 300);
			}
		} else {
			cartDrawerUpsell.classList.remove('productPopUp__upsell--active');

			const addToCartPromise = await fetch(window.Shopify.routes.root + 'cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData),
			});

			if (!addToCartPromise.ok) {
				popUpError();
			}

			if (window.location.pathname == '/cart') {
				document.location.reload();
			}

			await addToCartPromise.json().then((data) => {
				checkProductData(data);
			});

			await window.updatePopUp();

			if (document.querySelector('.add-to-cart--loading')) {
				setTimeout(() => {
					document.querySelector('.add-to-cart--loading').classList.remove('add-to-cart--loading');
				}, 300);
			}
		}

		window.liQ = window.liQ || [];

		if (currentProduct.dataset.price) {
			window.liQ.push({
				"event": "addToCart",
				"email": `${customerEmail ? customerEmail.dataset.account : ''}`,
				"items": [
				{
					"id": `${currentID}`,
					"price": `${currentProduct.dataset.price}`,
					"quantity": `${currentQuantity ? currentQuantity : 1}`,
					"currency": `${Shopify.currency.active}`
					}
				]
			 });
		}
	}

	window.updatePopUp = async function updatePopUp(isOpen = true) {
		const cartDrawerResponse = await fetch('?section_id=product-pop-up');
		const cartDrawerLayout = new DOMParser().parseFromString(await cartDrawerResponse.text(), 'text/html');
		const cartDrawerContent = document.querySelector('.productPopUp .productPopUp__wrapper');
		const responseDrawerWrapper = cartDrawerLayout.querySelector('.productPopUp .productPopUp__wrapper');

		cartDrawerContent.outerHTML = responseDrawerWrapper.outerHTML;

		const bundleSize = responseDrawerWrapper.dataset.bundleSize ? responseDrawerWrapper.dataset.bundleSize : '';

		if (+bundleSize == 2) {
			const bundleProductsArray = document.querySelectorAll('[data-bundle-key]');

			await fetch('/cart/change.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(
					{
						id: bundleProductsArray[0].dataset.bundleKey,
						properties: {
							'_bundle': ''
						}
					}
				)
			});

			const changeData = await fetch('/cart/change.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(
					{
						id: bundleProductsArray[1].dataset.bundleKey,
						properties: {
							'_bundle': ''
						}
					}
				)
			});

			if (changeData.ok) {
				await window.updatePopUp();
			}
		}

		const cartDrawerUpsellProducts = document.querySelectorAll('.productPopUp__alsoBought .productPopUp__alsoBoughtItemContenButton');
		const popUpCloseButtonsArray = document.querySelectorAll('.productPopUp--close');
		const cartCount = document.querySelector('[data-cart-count]');
		const cartCountIcon = document.querySelector('.minicart-count');
		const cartCircle = document.querySelector('.minicart__cartCircle');

		if (+cartCount.dataset.cartCount === 0) {
			cartCountIcon.classList.add('minicart-count--hidden');
			cartCircle?.classList.add('minicart-count--hidden');
		} else {
			cartCountIcon.classList.remove('minicart-count--hidden');
			cartCircle?.classList.remove('minicart-count--hidden');
			cartCountIcon.innerText = +cartCount.dataset.cartCount;
		}

		cartDrawerUpsellProducts.forEach(product => {
			product.addEventListener('click', (event)=> {
				event.preventDefault();
				addToCart(event);
			});
		});

		popUpCloseButtonsArray.forEach(button => {
			button.addEventListener('click', closePopUp);
		});

		initSlider();

		if (isOpen) {
			openPopUp();
		}

		if (getCookie('isFirstCustomer')) {
			window.toggleFirstCustomerDiscount();
		}

		if (document.querySelector('[data-cleaner-hidden]')) {
			window.is_cleaner_hidden = true;
		} else {
			window.is_cleaner_hidden = false;
		}

		$('.productPopUp__alsoBought--slider').each(function() {
			if (window.is_cleaner_hidden) {
				$(this).slick("slickFilter", ":not(.slide-hidden)");
			} else {
				$(this).slick('slickUnfilter');
			}
		});
	}

	function checkboxHandler(currentID) {
		const upsellProducts = document.querySelectorAll('.productPopUp__list .productPopUp__listItem');
		let menLaces = '110 cm';
		let womenLaces = '105 cm';
		let menTrees = 'XL';
		let womenTrees = 'S';

		upsellProducts.forEach((product) => {
			const currentProductVariants = JSON.parse(product.dataset.variants);
			const currentVariantsAvailable = JSON.parse(product.dataset.available);

			if (product.dataset.type == 'men') {
				if (product.dataset.name == 'laces') {
					const menLacesSizesBig = [13, 14, 15, 16];

					if (menLacesSizesBig.includes(+currentID)) {
						menLaces = '120 cm'
					}

					product.dataset.variantId = currentProductVariants[menLaces];

					if (currentVariantsAvailable[menLaces] === 'false') {
						product.classList.add('productPopUp__listItem--hidden');
					}
				} else if (product.dataset.name == 'tree') {
					if (currentID == '7') {
						menTrees = 'S';
					} else if (currentID == '8' || currentID == '9') {
						menTrees = 'M';
					} else if (currentID == '10' || currentID == '11') {
						menTrees = 'L';
					}

					product.dataset.variantId = currentProductVariants[menTrees];

					if (currentVariantsAvailable[menTrees] === 'false') {
						product.classList.add('productPopUp__listItem--hidden');
					}
				}
			} else if (product.dataset.type == 'women') {
				if (product.dataset.name == 'laces') {
					if (currentID == '11') {
						womenLaces = '110 cm';
					}

					product.dataset.variantId = currentProductVariants[womenLaces];

					if (currentVariantsAvailable[womenLaces] === 'false') {
						product.classList.add('productPopUp__listItem--hidden');
					}
				} else if (product.dataset.name == 'tree') {
					if (currentID == '11') {
						womenTrees = 'M';
					}

					product.dataset.variantId = currentProductVariants[womenTrees];

					if (currentVariantsAvailable[womenTrees] === 'false') {
						product.classList.add('productPopUp__listItem--hidden');
					}
				}
			}

			if (product.dataset.name == '') {
				const key = Object.keys(currentProductVariants).find(key => currentProductVariants[key] === product.dataset.variantId);

				if (currentVariantsAvailable[key] && currentVariantsAvailable[key] === 'false') {
					product.classList.add('productPopUp__listItem--hidden');
				}
			}
		});
	}

	async function addBundle(id, sellingPlanResponse, price, isOpenDrawer = true) {
		const upsellCheckedItems = document.querySelectorAll('.productPopUp .productPopUp__upsell .productPopUp__listItem input:checked');
		const upsellSection = document.querySelector('.productPopUp .productPopUp__upsell');
		const productPopUp = document.querySelector('.productPopUp__wrapper');
		const popUpOverlayBundle = document.querySelector('.productPopUp__overlayBundle');

		productPopUp.classList.remove('productPopUp--fadeIn');
		popUpOverlayBundle.classList.remove('productPopUp__overlayBundle--active');

		if (!isOpenDrawer) {
			const cartDrawer = document.querySelector('.productPopUp');

			cartDrawer.classList.remove('productPopUp--open');
		}

		if (upsellCheckedItems.length) {
			const uniqID = uuidv4();
			const properties = {};
			const formData = {
				items: [],
				attributes: {
					"ga4_user_id": getFirstNonDeletedCookie('_ga_XPYPPV3XZQ') ? getFirstNonDeletedCookie('_ga_XPYPPV3XZQ') : '',
				}
			};

			properties._bundleItem = uniqID;
			properties._bundleItemTitle = 'main';
			properties._generatedId = Date.now();

			if (price) properties._productPrice = price;

			formData.items.push({
				'id': +id,
				'quantity': 1,
				properties,
				selling_plan: sellingPlanResponse,
			});

			upsellCheckedItems.forEach((checkbox) => {
				const checkedItem = checkbox.closest('.productPopUp__listItem');
				const properties = {};

				properties._upsellValue = checkedItem.dataset.upsell;
				properties._bundleItem = uniqID;
				properties._bundleItemTitle = 'child';
				properties._productPrice = checkedItem.dataset.productPrice;

				formData.items.push({
					'id': +checkedItem.dataset.variantId,
					'quantity': 1,
					properties,
				});
			});

			const addToCartPromise = await fetch(window.Shopify.routes.root + 'cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData),
			});

			if (!addToCartPromise.ok) {
        throw new Error('Failed to add product');
      }

			await addToCartPromise.json().then((data) => {
				checkProductData(data);
			});

			upsellSection.classList.remove('productPopUp__upsell--active');

			if (isOpenDrawer) productPopUp.classList.remove('productPopUp--hidden');

			setTimeout(() => {
				popUp.classList.add('productPopUp--fadeIn');
			}, 800);
		} else {
			const addToCartPromise = await fetch(window.Shopify.routes.root + 'cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					items: [{
						'id': +id,
						'quantity': 1,
						'selling_plan': sellingPlanResponse,
						'properties': {
							"_productPrice": price,
							"_generatedId": Date.now(),
						}
					}],
					attributes: {
						"ga4_user_id": getFirstNonDeletedCookie('_ga_XPYPPV3XZQ') ? getFirstNonDeletedCookie('_ga_XPYPPV3XZQ') : '',
					}
				}),
			});

			if (!addToCartPromise.ok) {
        popUpError();
      }

			await addToCartPromise.json().then((data) => {
				checkProductData(data);
			});

			if (window.location.pathname == '/cart') {
				document.location.reload();
			}

			upsellSection.classList.remove('productPopUp__upsell--active');
			if (isOpenDrawer) productPopUp.classList.remove('productPopUp--hidden');

			if (document.querySelector('.add-to-cart--loading')) {
				setTimeout(() => {
					document.querySelector('.add-to-cart--loading').classList.remove('add-to-cart--loading');
				}, 300);
			}

			setTimeout(() => {
				productPopUp.classList.add('productPopUp--fadeIn');
			}, 800);
		}

		await window.updatePopUp(isOpenDrawer);
	}

	function debounce(fn, wait) {
		let t;

		return (...args) => {
			clearTimeout(t);

			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}

	async function removeProduct(event) {
		const currentProductID = event.currentTarget.dataset.popupId;
		const currentProductIsGift = event.currentTarget.dataset.isGift;
		const removeObject = {};

		removeObject[currentProductID] = 0;

		if (
			event.currentTarget.dataset.popupBundleItem
			&& event.currentTarget.dataset.popupBundleType == 'main'
		) {
			const bundleItems = document.querySelectorAll(`.productPopUp__productRemove[data-popup-bundle-item="${event.currentTarget.dataset.popupBundleItem}"]`);

			bundleItems.forEach((item) => {
				removeObject[item.dataset.popupId] = 0;
			});
		}

		const removeData = await fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-type': 'application/json'
			},
			body: JSON.stringify({
        updates: removeObject,
      }),
		});

		if (removeData.ok) {
			await window.updatePopUp();
		}
	}

	function updateCartCount(cart) {
		const currentHeaderCartCount = document.querySelector('.minicart-count');

		if (currentHeaderCartCount) {
			currentHeaderCartCount.innerHTML = cart.item_count;

			if (cart.item_count == 0) {
				currentHeaderCartCount.classList.add('minicart-count--hidden');
			} else {
				currentHeaderCartCount.classList.remove('minicart-count--hidden');
			}
		}
	}

	function openPopUp() {
		let removeButtons = document.querySelectorAll('.productPopUp__productRemove'),
				cartDrawerPricesDiscounted = document.querySelectorAll('.productPopUp__productDiscountedPrice[data-cart-drawer-discount-price]'),
				cartDrawerProductsPrices = document.querySelectorAll('.productPopUp__productFullPrice[data-cart-drawer-discount-price]'),
				subtotalCartPrice = document.querySelector('.productPopUp__subtotalPrice'),
				originalCartPrice = document.querySelector('.productPopUp__originalPrice'),
				firstCustomerValue = document.querySelector('.firstCustomerValue'),
				closeButton = document.querySelector('.productPopUp__headerLinkWrapper.productPopUp--close'),
				lastProductDiscountPrice,
				lastProductFullPrice,
				productPopUp = document.querySelector('.productPopUp__wrapper');

		productPopUp.classList.remove('productPopUp--fadeIn');

		if (cartDrawerPricesDiscounted[cartDrawerPricesDiscounted.length - 1]) {
			lastProductDiscountPrice = cartDrawerPricesDiscounted[cartDrawerPricesDiscounted.length - 1],
			lastProductFullPrice = cartDrawerProductsPrices[cartDrawerProductsPrices.length - 1];
		}

		addOffsetTop();

		removeButtons.forEach(removeButton => {
			removeButton.addEventListener('click', event => {
				removeProduct(event);
			});
		});

		if (getCookie('isFirstCustomer') && lastProductDiscountPrice && lastProductFullPrice && firstCustomerValue) {
			let cartCount = document.querySelector('.minicart-count');
			let priceDifference = 0;

			if (lastProductFullPrice.innerText != '') {
				lastProductFullPrice.innerText = formatMoney(parseInt(lastProductFullPrice.dataset.cartDrawerDiscountPrice) - firstCustomerValue.innerText);
				priceDifference = +lastProductFullPrice.dataset.cartDrawerDiscountPrice - (parseInt(lastProductFullPrice.dataset.cartDrawerDiscountPrice) - firstCustomerValue.innerText);
			} else {
				lastProductFullPrice.innerText = formatMoney(parseInt(lastProductDiscountPrice.dataset.cartDrawerDiscountPrice));
				lastProductDiscountPrice.innerText = formatMoney(parseInt(lastProductDiscountPrice.dataset.cartDrawerDiscountPrice) - firstCustomerValue.innerText);
				lastProductDiscountPrice.closest('.productPopUp__productPrice').classList.add('productPopUp__productPriceDiscoutRevert');
				priceDifference = +lastProductDiscountPrice.dataset.cartDrawerDiscountPrice - (parseInt(lastProductDiscountPrice.dataset.cartDrawerDiscountPrice) - firstCustomerValue.innerText);
			}

			if (parseInt(cartCount.innerText) >= 1) {
				if (!subtotalCartPrice.classList.contains('hidden')) {
					subtotalCartPrice.innerText = formatMoney(parseInt(subtotalCartPrice.dataset.subtotal) - priceDifference);
				} else {
					originalCartPrice.innerText = formatMoney(parseInt(originalCartPrice.dataset.originalPrice) - priceDifference);
				}
			}
		}

		popUp.classList.add('productPopUp--open');
		document.querySelector('body').classList.add('overflow');

		if (window.innerWidth <= 768) {
			document.querySelector('html').style.height = `${window.innerHeight}px`;
		}

		closeButton.focus();
		window.initToggleExchangeProduct();

		const debounceDrawer = debounce(() => {
			productPopUp.classList.add('productPopUp--fadeIn');
		}, 800);

		debounceDrawer();
	}

	function closePopUp() {
		const cartIcon = document.querySelector('.header__cartInfoLink');

		removeOffsetTop();

		popUp.classList.remove('productPopUp--open');
		document.querySelector('body').classList.remove('overflow');

		if (window.innerWidth <= 768) {
			document.querySelector('html').style.height = 'auto';
		}

		cartIcon.focus();
	}

	function popUpError() {
		const popUpError = document.querySelector('.productPopUpError');

		popUpError.classList.add('productPopUpError--open');
		setTimeout(popUpErrorClose, 2500);
	}

	function popUpErrorClose() {
		const popUpError = document.querySelector('.productPopUpError');

		popUpError.classList.remove('productPopUpError--open');
	}

	function showProductTryText() {
		const productTryText = document.querySelector('.productPopUp__productTryText');

		productTryText.classList.add('productPopUp__productTryTextActive');
	}

	function alsoBoughtRemove() {
		const alsoBoughSection = document.querySelector('.productPopUp__alsoBought');

		alsoBoughSection.remove();
	}

	function openTermsLink(event, hash) {
    const currentTermsContent = document.querySelector(`.header__terms[data-terms-link="${hash}"]`);

    if (currentTermsContent) {
      event.preventDefault();
      currentTermsContent.classList.add('header__terms--active');
      overlap.classList.add('overlap--active');
      body.classList.add('body--overflow');
    }
  }

function addToCartFunctionlity() {
	let catalogProductsArray = document.querySelectorAll('.quick-add__size'),
			popUpCloseButtonsArray = document.querySelectorAll('.productPopUp--close'),
			popUp = document.querySelector('.productPopUp'),
			productAddToCartButton = document.querySelector('.add-to-cart'),
			cartDrawerProducts = document.querySelectorAll('.productPopUp__alsoBought .productPopUp__alsoBoughtItemContenButton'),
			cartAddButtonsArray = document.querySelectorAll('.minicart-quick-add-to-cart-btn'),
			popUpOverlay = document.querySelector('.productPopUp__overlay'),
			headerCartText = document.querySelector('.minicart-toggle-btn'),
			fullPageProductButtonsArray = document.querySelectorAll('.collectionFullpageProduct__contentFooterButton:not(.collectionFullpageProduct__contentFooterButton--preorder)'),
			fullPageTemplate = document.querySelector('.collectionFullpage__list.products');

	popUpCloseButtonsArray.forEach(button => {
		button.addEventListener('click', closePopUp);
	});

	popUpOverlay.addEventListener('click', event => {
		popUp.classList.remove('productPopUp--open');
		document.querySelector('body').classList.remove('overflow');
	});

	if(!fullPageTemplate && !document.querySelector('.collectionSlider') && !document.querySelector('.customSlider')) {
		catalogProductsArray.forEach(product => {
			product.addEventListener('click', (event => {
				event.preventDefault();
				addToCart(event);
			}));
		});
	}

	cartAddButtonsArray.forEach(product => {
		product.addEventListener('click', (event => {
			event.preventDefault();
			addToCart(event);
		}));
	});

	if (productAddToCartButton) {
		productAddToCartButton.addEventListener('click', event => {
			event.preventDefault();
			addToCart(event);
		});
	};

	cartDrawerProducts.forEach(product => {
		product.addEventListener('click', (event)=> {
			event.preventDefault();
			addToCart(event);
		});
	});

	if (headerCartText && window.location.pathname != '/cart') {
		headerCartText.addEventListener('click', event => {
			event.preventDefault();
			openPopUp();
		});
	}

	if (window.location.pathname.includes('/products/')) {
		setTimeout(function searchTryButton() {
			let productTryButton = document.querySelector('#bcButton');

			if (productTryButton == null) {
				setTimeout(searchTryButton, 10);
			} else {
				productTryButton.addEventListener('click', event => {
					event.preventDefault();
					addToCart(event);
				});
			}
		}, 10);
	}

	fullPageProductButtonsArray.forEach(button => {
		button.addEventListener('click', event => {
			event.preventDefault();
			addToCart(event);
		})
	});
};

addToCartFunctionlity();
